import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyThanksForRsvp = loadable(() => import(/* webpackChunkName: "content/thanksForRsvp" */ '.'));
